export const FormatBanks = (bank_id) => {
  switch (bank_id) {
    case 1:
      return "bbl";
    case 2:
      return "scb";
    case 3:
      return "kbank";
    case 4:
      return "bay";
    case 5:
      return "ktb";
    case 6:
      return "ttb";
    case 8:
      return "gsb";
    case 9:
      return "baac";
    case 10:
      return "uob";
    case 11:
      return "tisco";
    case 12:
      return "cimb";
    case 13:
      return "lhb";
    case 14:
      return "TRUE";
    case 15:
      return "Bonus";
    case 16:
      return "truewallet";
    case 17:
      return "tcrb";
    case 18:
      return "GHB";
    case 19:
      return "CITI";
    case 20:
      return "DB";
    case 21:
      return "HSBC";
    case 22:
      return "ICBC";
    case 23:
      return "ISBT";
    case 24:
      return "kkp";
    case 25:
      return "MHCB";
    case 26:
      return "SCBT";
    case 27:
      return "SMBC";
       case 28:
      return "KKP";

    default:
      return "No data";
  }
};

export const FormatBankCoed = (bank) => {
  const bankCode = bank;
  switch (bankCode) {
    case "scb":
      return "ธนาคารไทยพาณิชย์";
    case "SCB":
      return "ธนาคารไทยพาณิชย์";
    case "ktb":
      return "ธนาคารกรุงไทย";
    case "KTB":
      return "ธนาคารกรุงไทย";
    case "baac":
      return "ธนาคาร ธ.ก.ส";
    case "BAAC":
      return "ธนาคาร ธ.ก.ส";
    case "kbank":
      return "ธนาคารกสิกร";
    case "KBANK":
      return "ธนาคารกสิกร";
    case "bbl":
      return "ธนาคารกรุงเทพ";
    case "BBL":
      return "ธนาคารกรุงเทพ";
    case "bay":
      return "ธนาคารกรุงศรีอยุธยา";
    case "BAY":
      return "ธนาคารกรุงศรีอยุธยา";
    case "ttb":
      return "ธนาคารทหารไทย-ธนชาติ";
    case "TTB":
      return "ธนาคารทหารไทย-ธนชาติ";
    case "gsb":
      return "ธนาคารออมสิน";
    case "GSB":
      return "ธนาคารออมสิน";
    case "uob":
      return "ธนาคารยูโอบี";
    case "UOB":
      return "ธนาคารยูโอบี";
    case "tisco":
      return "ธนาคารทิสโก้";
    case "TISCO":
      return "ธนาคารทิสโก้";
    case "cimb":
      return "ธนาคารซีไอเอ็มบีไทย";
    case "CIMB":
      return "ธนาคารซีไอเอ็มบีไทย";
    case "lhb":
      return "ธนาคารแลนด์แอนด์เฮ้าส์";
    case "LHB":
      return "ธนาคารแลนด์แอนด์เฮ้าส์";
    case "kkp":
      return "ธนาคารเกียรตินาคินภัทร";
    case "KKP":
      return "ธนาคารเกียรตินาคินภัทร";
    case "KK":
      return "ธนาคารเกียรตินาคินภัทร";
    case "truewallet":
      return "ทรูมันนี่วอลเล็ท";
    case "TRUEWALLET":
      return "ทรูมันนี่วอลเล็ท";
    default:
      return "-";
  }
};
